
























































































































import Vue from 'vue';
import { FCheckboxGroup, FCheckboxGroupField, FRadioGroup, FRadioGroupField } from '@fkui/vue';
import { ValidationService } from '@fkui/logic';
import BtNumberField from './BtNumberField.vue';

export default Vue.extend({
    name: 'BtMinaInkomsterContent',
    components: {
        FCheckboxGroup,
        FCheckboxGroupField,
        FRadioGroup,
        FRadioGroupField,
        BtNumberField,
    },
    props: {
        saIsKund2: {
            type: Boolean,
            required: false,
        },
        componentId: {
            type: String,
            required: true,
        },
        incomeArbetsinkomstChecked: {
            type: Boolean,
            required: true,
        },
        incomeUtoverChecked: {
            type: Boolean,
            required: true,
        },
        incomeKapitalChecked: {
            type: Boolean,
            required: true,
        },
        incomeSABelopp: {
            type: String,
            required: true,
        },
        incomeArbetsinkomstBelopp: {
            type: String,
            required: true,
        },
        incomeUtoverBelopp: {
            type: String,
            required: true,
        },
        incomeKapitalBelopp: {
            type: String,
            required: true,
        },
        kund2harSa: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            id: 'btInkomsterContent',
            incomeData: {
                incomeArbetsinkomstChecked: this.incomeArbetsinkomstChecked,
                incomeUtoverChecked: this.incomeUtoverChecked,
                incomeKapitalChecked: this.incomeKapitalChecked,
                incomeSABelopp: this.incomeSABelopp,
                incomeArbetsinkomstBelopp: this.incomeArbetsinkomstBelopp,
                incomeUtoverBelopp: this.incomeUtoverBelopp,
                incomeKapitalBelopp: this.incomeKapitalBelopp,
                kund2harSa: this.kund2harSa,
            },
            validation: {
                inkomstStor: {
                    required: { errorMessage: this.$t('SBRV.RW.pengarfalt.etikett.fyllipengarfalt') },
                    minValue: { minValue: 0 },
                    maxValue: { maxValue: 99999999 },
                },
                inkomst: {
                    required: { errorMessage: this.$t('SBRV.RW.pengarfalt.etikett.fyllipengarfalt') },
                    minValue: { minValue: 0 },
                    maxValue: { maxValue: 99999 },
                },
            },
        };
    },
    methods: {
        radioChange() {
            if (!this.incomeData.kund2harSa) {
                this.incomeData.incomeSABelopp = '';
            }
            this.emit();
        },
        checkboxArbetsinkomstChange() {
            ValidationService.setState(`${this.componentId}-income-arbetsinkomst-belopp`, { touched: false });
            this.incomeData.incomeArbetsinkomstBelopp = '';
            this.emit();
        },
        checkboxUtoverChange() {
            ValidationService.setState(`${this.componentId}-income-utover-belopp`, { touched: false });
            this.incomeData.incomeUtoverBelopp = '';
            this.emit();
        },
        checkboxKapitalChange() {
            ValidationService.setState(`${this.componentId}-income-kapital-belopp`, { touched: false });
            this.incomeData.incomeKapitalBelopp = '';
            this.emit();
        },
        emit() {
            this.$emit('on-edit-emit', this.incomeData);
        },
    },
});
